import { render, staticRenderFns } from "./ReassignProcessorModal.vue?vue&type=template&id=35a89342&scoped=true&"
import script from "./ReassignProcessorModal.vue?vue&type=script&lang=js&"
export * from "./ReassignProcessorModal.vue?vue&type=script&lang=js&"
import style0 from "./ReassignProcessorModal.vue?vue&type=style&index=0&id=35a89342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a89342",
  null
  
)

export default component.exports